import { render, staticRenderFns } from "./ArticleSitecore.vue?vue&type=template&id=4a3a017a"
import script from "./ArticleSitecore.vue?vue&type=script&lang=js"
export * from "./ArticleSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports